import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const apiBase = process.env.REACT_APP_API_BASE || '';
const excludedPaths = new Set(['/serverstatus', '/terminal']);

const createId = () => {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

const getStoredId = (storage, key) => {
  try {
    const existingId = storage.getItem(key);

    if (existingId) {
      return existingId;
    }

    const nextId = createId();
    storage.setItem(key, nextId);
    return nextId;
  } catch (error) {
    return createId();
  }
};

function VisitorTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname || '/';
    const normalizedPath = path.toLowerCase();

    if (
      excludedPaths.has(normalizedPath)
      || navigator.doNotTrack === '1'
      || navigator.webdriver
      || /ReactSnap|HeadlessChrome/i.test(navigator.userAgent)
    ) {
      return;
    }

    const now = Date.now();
    const pageKey = `dinoPageView:${normalizedPath}`;

    try {
      const lastTrackedAt = Number(sessionStorage.getItem(pageKey) || 0);

      if (now - lastTrackedAt < 10000) {
        return;
      }

      sessionStorage.setItem(pageKey, String(now));
    } catch (error) {
      // Tracking can continue when storage is unavailable.
    }

    const visitorId = getStoredId(localStorage, 'dinoVisitorId');
    const sessionId = getStoredId(sessionStorage, 'dinoVisitSessionId');
    let referrer = '';

    try {
      if (!sessionStorage.getItem('dinoReferrerRecorded')) {
        referrer = document.referrer;
        sessionStorage.setItem('dinoReferrerRecorded', 'true');
      }
    } catch (error) {
      referrer = document.referrer;
    }

    fetch(`${apiBase}/api/analytics/visit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path, visitorId, sessionId, referrer }),
      keepalive: true,
    }).catch(() => {
      // Analytics should never interrupt the website experience.
    });
  }, [location.pathname]);

  return null;
}

export default VisitorTracker;
